import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useMe, useStopImpersonation } from '../api/hooks.js';

// « Voir comme » — bandeau permanent. Rendu par AuthGuard, seul
// ancêtre commun au shell staff et à l'Espace employé : impersonner
// un EMPLOYEE bascule sur /espace, le bandeau doit suivre.

export function ImpersonationBanner() {
  const me = useMe();
  const stop = useStopImpersonation();
  const navigate = useNavigate();
  const target = me.data?.impersonating ?? null;

  // Plutôt que de recouvrir les deux barres collantes (sidebar,
  // topbar), le bandeau les décale : elles lisent --banner-h.
  useEffect(() => {
    const root = document.documentElement;
    if (target) root.style.setProperty('--banner-h', '40px');
    else root.style.removeProperty('--banner-h');
    return () => {
      root.style.removeProperty('--banner-h');
    };
  }, [target]);

  if (!target) return null;

  const onQuit = async () => {
    await stop.mutateAsync();
    navigate('/', { replace: true });
  };

  return (
    <div className="imp-banner" role="status" data-testid="impersonation-banner">
      <span className="imp-banner-text">
        Vous voyez l'application comme <strong>{target.name}</strong> ({target.role})
      </span>
      <button
        type="button"
        className="imp-banner-quit"
        onClick={onQuit}
        disabled={stop.isPending}
        data-testid="impersonation-quit"
      >
        Quitter
      </button>
    </div>
  );
}
